import { combineReducers } from 'redux'

import app from './app'

export default combineReducers({
  app
})



// WEBPACK FOOTER //
// ./src/reducers/index.js